import {doc, getDoc, getFirestore, updateDoc} from 'firebase/firestore';
import {getFunctions, httpsCallable} from 'firebase/functions';
import {useEffect, useState} from 'react';
import {getToken} from "firebase/messaging";
import {messaging} from "../firebase/firebase";
import {getAuth} from "firebase/auth";

const vapidKey = 'BAy7wA1NRHt5Ho1zRIjNHncjaQzVDJh_0LN5OjYGjM_qbqmHUBXTofO6hkLZD7KUo1siXNwaCd1s0J0i2Eez5W8';

const Settings = () => {
  const db = getFirestore();

  const [subEnabled, setSubEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  // Ініціалізуємо Firebase Functions
  const functions = getFunctions();
  const updateSettingsFunction = httpsCallable(functions, 'updateSettings');

  // Завантаження налаштувань при монтуванні компонента
  useEffect(() => {
    const fetchSettings = async () => {
      setLoading(true);
      try {
        const settingsRef = doc(db, 'settings', 'subSettings');
        const docSnap = await getDoc(settingsRef);

        if (docSnap.exists()) {
          setSubEnabled(docSnap.data().subEnabled || false);
        } else {
          // Якщо документу немає, відображаємо значення за замовчуванням
          setSubEnabled(false);
        }
        setError(null);
      } catch (err) {
        console.error('Помилка при отриманні налаштувань:', err);
        setError('Не вдалося завантажити налаштування');
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, [db]);

  // Функція для оновлення налаштування
  const handleToggleSubEnabled = async () => {
    setUpdating(true);
    setSuccess(false);
    setError(null);

    try {
      // Викликаємо Cloud Function для оновлення налаштування
      const result = await updateSettingsFunction({
        settingsPath: 'settings/subSettings',
        settings: {
          subEnabled: !subEnabled,
        },
      });

      // Перевіряємо результат
      if (result.data && result.data.success) {
        setSubEnabled(!subEnabled);
        setSuccess(true);

        // Приховуємо повідомлення про успіх через 3 секунди
        setTimeout(() => {
          setSuccess(false);
        }, 3000);
      } else {
        setError('Помилка при оновленні налаштувань');
      }
    } catch (err) {
      console.error('Помилка при виклику функції оновлення:', err);
      setError(
        `Не вдалося оновити налаштування: ${err.message || 'Невідома помилка'}`
      );
    } finally {
      setUpdating(false);
    }
  };

  const requestPermission = async (uid) => {
    try {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        const token = await getToken(messaging, {vapidKey});

        const userRef = doc(db, 'admins', uid);
        const userSnap = await getDoc(userRef);

        if (userSnap.exists()) {
          const data = userSnap.data();
          const tokens = data.fcmTokens || [];

          if (!tokens.includes(token)) {
            await updateDoc(userRef, {
              fcmTokens: [...tokens, token],
            });
          }
        }

        setSuccess(true);
        setLoading(false);
      } else {
        console.log('Дозвіл на повідомлення відхилено');
      }
    } catch (error) {
      console.error('Помилка при отриманні токена', error);
    }
  };

  const createAccount = async (e) => {
    e.preventDefault();

    setLoading(true);

    const auth = getAuth();
    const user = auth.currentUser;
    const uid = user.uid;
    const email = user.email;

    try {
      const adminRef = doc(db, 'admins', uid);
      const adminSnap = await getDoc(adminRef);

      if (!adminSnap.exists()) {
        const functions = getFunctions();
        const registerAdminFn = httpsCallable(functions, 'registerAdmin');
        await registerAdminFn({
          id: uid,
          email
        });
      }
    } catch (error) {
      console.error('Помилка при спробі створити юзера в БД:', error);
      setError(
        `Помилка при спробі створити юзера в БД:: ${error.message || 'Невідома помилка'}`
      );
    }

    await requestPermission(uid);
  }

  return (
    <div style={{padding: 24}}>
      <div style={{color: '#FFFDFE', fontSize: '24px', marginBottom: '24px'}}>
        Налаштування
      </div>

      {error && (
        <div
          style={{
            backgroundColor: '#FEE2E2',
            color: '#B91C1C',
            padding: '10px',
            borderRadius: '4px',
            marginBottom: '16px',
          }}
        >
          {error}
        </div>
      )}

      {success && (
        <div
          style={{
            backgroundColor: '#DCFCE7',
            color: '#166534',
            padding: '10px',
            borderRadius: '4px',
            marginBottom: '16px',
          }}
        >
          Налаштування успішно оновлено
        </div>
      )}

      <div
        style={{
          backgroundColor: '#2D3748',
          padding: '16px',
          borderRadius: '8px',
          marginBottom: '16px',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div>
            <h3 style={{color: '#FFFDFE', margin: '0 0 8px 0'}}>
              Підписка для майстрів
            </h3>
            <p style={{color: '#A0AEC0', margin: '0'}}>
              {subEnabled
                ? 'Майстри повинні мати активну підписку, щоб відповідати на запити'
                : 'Майстри можуть відповідати на запити без активної підписки'}
            </p>
          </div>

          <div style={{display: 'flex', alignItems: 'center'}}>
            <label
              style={{
                position: 'relative',
                display: 'inline-block',
                width: '60px',
                height: '34px',
              }}
            >
              <input
                type='checkbox'
                checked={subEnabled}
                onChange={handleToggleSubEnabled}
                disabled={loading || updating}
                style={{
                  opacity: 0,
                  width: 0,
                  height: 0,
                }}
              />
              <span
                style={{
                  position: 'absolute',
                  cursor: loading || updating ? 'not-allowed' : 'pointer',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: subEnabled ? '#FF8E04' : '#4B5563',
                  opacity: loading || updating ? 0.5 : 1,
                  transition: '.4s',
                  borderRadius: '34px',
                }}
              >
                <span
                  style={{
                    position: 'absolute',
                    content: '""',
                    height: '26px',
                    width: '26px',
                    left: subEnabled ? '30px' : '4px',
                    bottom: '4px',
                    backgroundColor: '#FFFDFE',
                    transition: '.4s',
                    borderRadius: '50%',
                  }}
                />
              </span>
            </label>
            {updating && (
              <span
                style={{
                  marginLeft: '10px',
                  color: '#A0AEC0',
                  display: 'inline-block',
                }}
              >
                Оновлення...
              </span>
            )}
          </div>
        </div>
      </div>
      <button
        disabled={loading}
        style={{
          backgroundColor: '#ff8e04',
          color: 'white',
          border: 'none',
          height: 36,
          width: 'fit-content',
          borderRadius: 24,
          cursor: 'pointer',
        }}
        onClick={createAccount}
      >
        Ввімкнути веб пуш повідомлення
      </button>
    </div>
  );
};

export default Settings;
